import { create } from 'zustand';

import { Point2D } from '@paragon/geometry-library';
import { roundToIncrement } from '@paragon/utilities';

// We snap the view center to a grid of this size so it only changes once the camera has moved a meaningful distance.
const VIEW_CENTER_GRID_SIZE = 240;

const viewCenterStore = create<{ value: Point2D }>(() => ({ value: Point2D.origin }));

/**
 * Returns the (approximate) center of the layout camera's view in layout coordinates, re-rendering whenever it changes.
 *   Use this to clip visuals of infinite geometry (see `clipLineAroundPoint`).
 */
export function useViewCenter(enabled = true): Point2D {
  return viewCenterStore(({ value }) => (enabled ? value : Point2D.origin));
}

export function updateViewCenter(target: { x: number; z: number }): void {
  // note that `target` is in design coordinates because it's coming straight from the camera controls
  const x = roundToIncrement(target.x, VIEW_CENTER_GRID_SIZE);
  const y = roundToIncrement(-target.z, VIEW_CENTER_GRID_SIZE);

  const { value } = viewCenterStore.getState();
  if (x !== value.x || y !== value.y) {
    viewCenterStore.setState({ value: new Point2D(x, y) });
  }
}
